export default __webpack_public_path__ + "static/media/medication@2x.243a0d7d.jpg";